import { QueryClient } from "@tanstack/react-query";
import { ApiError } from "./client";

// Every error the API layer rejects with is an ApiError; this types `error` in all hooks.
declare module "@tanstack/react-query" {
  interface Register {
    defaultError: ApiError;
  }
}

/** A 4xx will not get better by asking again; anything else (5xx, no connection) gets one more try. */
export function shouldRetry(failureCount: number, error: unknown): boolean {
  if (error instanceof ApiError && error.status >= 400 && error.status < 500) return false;
  return failureCount < 1;
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, retry: shouldRetry },
  },
});
